// extracted by mini-css-extract-plugin
export default {"elements":"Navbar_elements__EmbHk","hamburger":"Navbar_hamburger__pO2aG","active-link":"Navbar_active-link__F9raU","active":"Navbar_active__MLHq1"};